import { render } from "./gbbd.vue?vue&type=template&id=c5bcec4e&scoped=true&ts=true"
import script from "./gbbd.vue?vue&type=script&lang=ts"
export * from "./gbbd.vue?vue&type=script&lang=ts"

import "./gbbd.vue?vue&type=style&index=0&id=c5bcec4e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bcec4e"]])

export default __exports__